/**
 * Ľudské názvy notifikačných topicov (kľúče = kanonický `chosen_notifications.type`
 * po `collapseChosenStoredType`, zhodné s backend/app/Support/NotificationTopic.php).
 *
 * Mapovanie stránok → topic ostáva v notificationTopics.js (PAGE_TO_TOPIC).
 * Tu upravuješ len texty v dialógi „Nastaviť notifikácie“ a pod.
 */

export const NOTIFICATION_TOPIC_DISPLAY_LABEL = {
  'maintenance.types': 'NotificationTopic.maintenance.types',
  'maintenance.scheduled_records': 'NotificationTopic.maintenance.scheduled_records',
  'maintenance.machine_cards': 'NotificationTopic.maintenance.machine_cards',
  /** service_tasks + service_task.* – preklady v locales (`NotificationTopic.Portal.*`), pozri notificationTopics.js. */
  'maintenance.machine_states': 'NotificationTopic.maintenance.machine_states',
  'maintenance.check_records': 'NotificationTopic.maintenance.check_records',
  'maintenance.machines': 'NotificationTopic.maintenance.machines',
  'maintenance.templates': 'NotificationTopic.maintenance.templates',
  'maintenance.companies': 'NotificationTopic.maintenance.companies',
  'maintenance.summary_emails': 'NotificationTopic.maintenance.summary_emails',
  'maintenance.preview': 'NotificationTopic.maintenance.preview',
  'maintenance.setup': 'NotificationTopic.maintenance.setup',

  'priorities.list': 'NotificationTopic.priorities.list',
  'priorities.settings': 'NotificationTopic.priorities.settings',

  'otk.internal_errors': 'NotificationTopic.otk.internal_errors',
  'otk.external_errors': 'NotificationTopic.otk.external_errors',
  'otk.complaints': 'NotificationTopic.otk.complaints',
  'otk.preview': 'NotificationTopic.otk.preview',
  'otk.documentation': 'NotificationTopic.otk.documentation',
  summary_email_otk: 'NotificationTopic.summary_email_otk',
  'otk.setup': 'NotificationTopic.otk.setup',
  'otk.statistics': 'NotificationTopic.otk.statistics',
  'painting.preview': 'NotificationTopic.painting.preview',
  'painting.conditions': 'NotificationTopic.painting.conditions',
  'painting.weather': 'NotificationTopic.painting.weather',
  'painting.intervals': 'NotificationTopic.painting.intervals',
  'painting.employee_conditions': 'NotificationTopic.painting.employee_conditions',
  'painting.time_conditions': 'NotificationTopic.painting.time_conditions',
  summary_email_painting: 'NotificationTopic.summary_email_painting',
  'calibration.preview': 'NotificationTopic.calibration.preview',
  'calibration.gauges': 'NotificationTopic.calibration.gauges',
  gauge_calibrations: 'NotificationTopic.gauge_calibrations',
  calibration_company_certificates: 'NotificationTopic.calibration_company_certificates',
  'calibration.setup': 'NotificationTopic.calibration.setup',

  'checklist.preview': 'NotificationTopic.checklist.preview',
  'checklist.setup': 'NotificationTopic.checklist.setup',
  checklist_templates: 'NotificationTopic.checklist_templates',
  checklist_records: 'NotificationTopic.checklist_records',
  summary_email_checklists: 'NotificationTopic.summary_email_checklists',

  'training.preview': 'NotificationTopic.training.preview',
  'training.employee_cards': 'NotificationTopic.training.employee_cards',
  'training.type_definitions': 'NotificationTopic.training.type_definitions',
  training_templates: 'NotificationTopic.training_templates',
  training_cards: 'NotificationTopic.training_cards',
  'training.lists': 'NotificationTopic.training.lists',
  training_employees: 'NotificationTopic.training_employees',
  training_invitations: 'NotificationTopic.training_invitations',
  training_invitation_templates: 'NotificationTopic.training_invitation_templates',
  training_company_certificates: 'NotificationTopic.training_company_certificates',
  training_companies: 'NotificationTopic.training_companies',
  'training.setup': 'NotificationTopic.training.setup',
  'training.lecturers': 'NotificationTopic.training.lecturers',

  'settings.business_partners': 'NotificationTopic.settings.business_partners',
  'settings.units': 'NotificationTopic.settings.units',
  'settings.checklist_holidays': 'NotificationTopic.settings.checklist_holidays',
  'settings.company_profile': 'NotificationTopic.settings.company_profile',
  'settings.customers': 'NotificationTopic.settings.customers',
  'settings.suppliers': 'NotificationTopic.settings.suppliers',
  'settings.departments': 'NotificationTopic.settings.departments',
  'settings.employees': 'NotificationTopic.settings.employees',
  support_tickets: 'NotificationTopic.support_tickets',
  'crm.levels': 'NotificationTopic.crm.levels',
  'crm.states': 'NotificationTopic.crm.states',
  'crm.traders': 'NotificationTopic.crm.traders',
  'crm.production_quality': 'NotificationTopic.crm.production_quality',
  'crm.sales_evaluation': 'NotificationTopic.crm.sales_evaluation',
  'crm.communication': 'NotificationTopic.crm.communication',

  otk_int: 'NotificationTopic.otk_int',
  root_causes: 'NotificationTopic.root_causes',
  companies: 'NotificationTopic.companies',
  machines: 'NotificationTopic.machines',
  machine_types: 'NotificationTopic.machine_types',
  users: 'NotificationTopic.users',
  roles: 'NotificationTopic.roles',
  otk_company_certificates: 'NotificationTopic.otk_company_certificates',
  otk_company_certificate: 'NotificationTopic.otk_company_certificate',
  otk_company_cert_state: 'NotificationTopic.otk_company_cert_state',
  otk_company_statistics: 'NotificationTopic.otk_company_statistics',
};
